
/**
 * params required
 * action: acción a realizar: 1: new | 2 editar
 * params: {
 *  idperson: 
 *  idpayroll:
 * }
 */

import { defineComponent, ref, inject, reactive, onMounted } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
//services
import masterService from "@/core/services/MasterService";
import GlobalService from '@/core/services/GlobalService';
import { errManager, showNotification } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";
export default defineComponent({
    name: "ModalAlergyPerson",
    props:{
        params: {
            type: null,
            required: true,
            default: ""
        },
        action: {
            type: Number,
            required: true,
            default: ""
        }
    },
    setup(props, {emit}) {
        const { t } = useI18n();
        const loader = ref(false)
        const dialogAlergy = inject<any>("dialogAlergy")
        const listSeverity = ref<any>([])
        const formRef = ref<FormInstance>()
        const formData = reactive(<any>{
            idperson : null,
            name: null,
            idseverity: null,
            reactions: null,
            mstatus: null
        })
        const rules = reactive<FormRules>({})

        const getListSeverity = async() => {
            await masterService.Details("api", btoa("29"))
            .then((res)=>{
                listSeverity.value = res.data
            })
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if(!formEl) return;
            formEl.resetFields();
        }

        const submitForm = async (formEl: FormInstance | undefined) => {
            if(!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid) {
                    if (props.action == 1)
                        onSave();
                    else
                        onUpdate();
                }
            });
        }

        const onOpen = () => {
            formData.idperson = ("idperson" in props.params) ? props.params.idperson : null
        }

        const onClosed = () => {
            resetForm(formRef.value)
        }

        const onSave = async() => {
            loader.value = true
            if(formData.idperson !=null){ //guardar en el servidor
                await GlobalService.post('allergy/save', formData)
                .then((res)=>{
                    loader.value = false
                    showNotification({title: res.data.title, message: res.data.message, status: res.data.status})
                    if(res.data.status == 'success'){
                        dialogAlergy.value = false
                        emit("onResponseAllergy", {status : true})
                    }
                }).catch(({response})=>{
                    loader.value = false
                    errManager(response)
                })
            } else {
                loader.value = false
                emit("onResponseAllergy", {status : false, params: {
                    idperson : formData.idperson,
                    name: formData.name,
                    idseverity: formData.idseverity,
                    reactions: formData.reactions,
                    mstatus: formData.mstatus
                }})
                dialogAlergy.value = false
            }
        }

        const onUpdate = () => {
            emit("onResponseAllergy", {status : true})
            //true: quiere decir que refresque la lista
        }

        onMounted(()=>{
            getListSeverity();

        })

        return {
            t,
            loader,
            dialogAlergy,
            formRef,
            formData,
            rules,
            listSeverity,

            //events
            getListSeverity,
            submitForm,
            resetForm,
            onClosed,
            onOpen
        }

    },
})
